export const emptyToNull = (value: string | null | undefined) => {
  if (!value) {
    return null
  }

  return value
}
